import { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import AuthLayout from '../components/AuthLayout';
import RegisterQuickForm from '../components/auth/RegisterQuickForm';
import { registerWithPassword } from '../services/api';

export default function Register() {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const redirectAfterRegister = location.state?.redirect;

  const handleRegister = async (payload) => {
    setIsSubmitting(true);
    try {
      const result = await registerWithPassword(payload);
      if (!result.success) return;
      const destination = result.user?.profileComplete === false
        ? '/complete-profile'
        : (redirectAfterRegister || '/dashboard');
      navigate(destination, { replace: true });
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <AuthLayout title="Registracija" subtitle="Kratka registracija i odmah nastavljate na onboarding">
      <div className="card max-w-xl mx-auto">
        <h2 className="text-2xl font-semibold text-gray-900 dark:text-gray-100 mb-1">Napravi nalog</h2>
        <p className="text-sm text-gray-600 dark:text-gray-400 mb-5">
          Samo osnovni podaci sada. Ostatak profila popunjavate kroz onboarding.
        </p>
        <RegisterQuickForm onSubmit={handleRegister} isSubmitting={isSubmitting} />
      </div>
    </AuthLayout>
  );
}


